// import { Input } from '@material-tailwind/react'
import { Listbox, Transition } from '@headlessui/react';
import { MagnifyingGlassIcon, MapPinIcon, XMarkIcon } from '@heroicons/react/24/solid'
import { Button, Drawer } from '@material-tailwind/react'
import React, { useState, useEffect } from 'react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'


const people = [
  { id: 1, name: 'Durward Reynolds', unavailable: false },
  { id: 2, name: 'Kenton Towne', unavailable: false },
  { id: 3, name: 'Therese Wunsch', unavailable: false },
  { id: 4, name: 'Benedict Kessler', unavailable: true },
  { id: 5, name: 'Katelyn Rohan', unavailable: false },
]

function EditSearch() {
  const [selected, setSelected] = useState(people[0])
  const [message, setMessage] = useState('');

  const handleChange = e => { setMessage(e.target.value) }
  const handleClick = () => { setMessage('') }

  const [open, setOpen] = useState(false);
  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setOpen(false); // Close the drawer on resize for small screens
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Run this effect only once when the component mounts

  const contentDrawerSearch = (
    <>
      {/* search for drawer*/}
      <div className='flex items-center py-1 mb-5 border-2 w-full md:w-2/3 rounded-md hover:border-black focus:ring-1 bg-gray-50'>
        <div className="flex items-center px-3.5 pointer-events-none">
          <MagnifyingGlassIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" />
        </div>
        <input
          onClick={window.innerWidth <= 768 ? openDrawer : null}
          type="text"
          id="input-group-1"
          className="p-0 w-full rounded-md border-transparent focus:border-transparent focus:ring-0 text-gray-900 text-sm bg-gray-50"
          placeholder="Cari Lowongan Kerja" />
      </div>

      {/* select */}
      <div className='block border-2 w-full mb-5 rounded-md hover:border-black focus:ring-1 bg-gray-50'>
        <Listbox value={selected} onChange={setSelected}>
          <div className="relative mt-1">
            <Listbox.Button className="relative w-full pl-3 text-left py-1">
              <span className="block truncate text-gray-500 text-sm ">{selected.name}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Transition
              // as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {people.map((person, personIdx) => (
                  <Listbox.Option
                    key={personIdx}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-amber-100 text-red-900' : 'text-gray-900'
                      }`
                    }
                    value={person}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                            }`}
                        >
                          {person.name}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
      </div>

      {/* city/province */}
      <div className='flex items-center border-2 w-full py-1 mb-5 rounded-md hover:border-black focus:ring-1 bg-gray-50'>
        <div className="flex items-center px-3.5 pointer-events-none">
          <MapPinIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" />
        </div>
        <input
          onChange={handleChange}
          value={message}
          type="text" id="input-group-1"
          className="p-0 w-full rounded-md border-transparent focus:border-transparent focus:ring-0 text-gray-900 text-sm bg-gray-50"
          placeholder="Cari Kota /Propinsi" />

        <button onClick={handleClick} type="button" className="flex items-center pr-3">
          <XMarkIcon className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white" />
        </button>
      </div>

      <Button className='w-full !static'>Carin</Button>
    </>
  )

  return (
    <div className='px-7 md:px-11'>
      {/* search for drawer*/}

      <div className='flex md:justify-center my-3 space-x-2'>

        <div className='flex items-center py-1 border-2 w-full md:w-2/3 rounded-md hover:border-black focus:ring-1 bg-gray-50'>
          <div className="flex items-center px-3.5 pointer-events-none">
            <MagnifyingGlassIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" />
          </div>
          <input onClick={window.innerWidth <= 768 ? openDrawer : null}
            type="text" id="input-group-1" className="p-0 w-full rounded-md border-transparent focus:border-transparent focus:ring-0 text-gray-900 text-sm bg-gray-50" placeholder="Cari Lowongan Kerja" />
        </div>


        <div className='hidden md:block border-2 w-2/3 rounded-md hover:border-black focus:ring-1 bg-gray-50'>
          <Listbox value={selected} onChange={setSelected}>
            <div className="relative mt-1 py-0.5">
              <Listbox.Button className="relative w-full pl-3 text-left">
                <p className="block truncate text-gray-500 text-sm">{selected.name}</p>
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <ChevronUpDownIcon
                    className="h-5 w-5 text-gray-500"
                    aria-hidden="true"
                  />
                </span>
              </Listbox.Button>
              <Transition
                // as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="z-10 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {people.map((person, personIdx) => (
                    <Listbox.Option
                      key={personIdx}
                      className={({ active }) =>
                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-amber-100 text-red-900' : 'text-gray-900'
                        }`
                      }
                      value={person}
                    >
                      {({ selected }) => (
                        <>
                          <span
                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                              }`}
                          >
                            {person.name}
                          </span>
                          {selected ? (
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </Listbox>
        </div>

        <div className='hidden md:flex items-center border-2 w-2/3 rounded-md hover:border-black focus:ring-1 bg-gray-50'>
          <div className="flex items-center px-3.5 pointer-events-none">
            <MapPinIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" />
          </div>
          <input onChange={handleChange} value={message}
            type="text" id="input-group-1" className="p-0 w-full rounded-md border-transparent focus:border-transparent focus:ring-0 text-gray-900 text-sm bg-gray-50" placeholder="Cari Kota /Propinsi" />

          <button onClick={handleClick} type="button" className="flex items-center pr-3">
            <XMarkIcon className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white" />
          </button>
        </div>


        <Button className='md:w-2/6 hidden md:block' size='md'>Cari</Button>


      </div>


      {window.innerWidth <= 768 && (
        <Drawer open={open} onClose={closeDrawer} className='w-full px-3 py-7'>
          {contentDrawerSearch}
        </Drawer>
      )}

    </div>
  )
}

export default EditSearch